import { createAction, handleActions } from "redux-actions";
import produce from "immer";
import { takeLatest } from "redux-saga/effects";
import createRequestSaga, {
  createRequestActionType,
} from "../lib/createRequestSaga";
import * as modalAPI from "../lib/api/modal";

// ! duplicate check는 사용하지 않음

const INITIALIZE_FORM = "modal/INITIALIZE_FORM";
const CHANGE_FIELD = "modal/CHANGE_FIELD";

// reviewing은 aixos 통신으로 진단검사 POST /review API 요청함을 뜻함(리뷰를 diagnosis_review DB에 등록했다는 뜻)
const [REVIEWING, REVIEWING_SUCCESS, REVIEWING_FAILURE] =
  createRequestActionType("modal/REVIEWING");

const [DUPLICATE_CHECK, DUPLICATE_CHECK_SUCCESS, DUPLICATE_CHECK_FAILURE] =
  createRequestActionType("modal/DUPLICATE_CHECK");

export const initializeForm = createAction(INITIALIZE_FORM, (form) => form);
export const changeField = createAction(CHANGE_FIELD, ({ key, value }) => ({
  key,
  value,
}));
export const reviewing = createAction(REVIEWING, ({ score, review }) => ({
  score,
  review,
}));
export const duplicateCheck = createAction(DUPLICATE_CHECK);

const reviewingSaga = createRequestSaga(REVIEWING, modalAPI.reviewing);
const duplicateCheckSaga = createRequestSaga(
  DUPLICATE_CHECK,
  modalAPI.duplicateCheck
);
export function* modalSaga() {
  yield takeLatest(REVIEWING, reviewingSaga);
  yield takeLatest(DUPLICATE_CHECK, duplicateCheckSaga);
}

// score는 평가 별점, review는 평가 의견, popupState는 모달창을 띄울지 말지 여부, success는 리뷰 등록 성공 여부
const initialState = {
  score: 5,
  review: "",
  popupState: false,
  is_duplicate: null,
  success: null,
};

const modal = handleActions(
  {
    [INITIALIZE_FORM]: (state, { payload: form }) => ({
      ...state,
      form,
    }),
    [CHANGE_FIELD]: (state, { payload: { key, value } }) =>
      produce(state, (draft) => {
        draft[key] = value;
      }),
    [REVIEWING_SUCCESS]: (state, { payload: success }) => ({
      ...state,
      success: success,
    }),
    [REVIEWING_FAILURE]: (state, { payload: error }) => ({
      ...state,
      success: error,
    }),
    [DUPLICATE_CHECK_SUCCESS]: (state, { payload: is_duplicate }) => ({
      ...state,
      is_duplicate: is_duplicate,
    }),
    [DUPLICATE_CHECK_FAILURE]: (state, { payload: error }) => ({
      ...state,
      is_duplicate: error,
    }),
  },
  initialState
);

export default modal;
